// src/pages/CalendarPage.js
import React, { useEffect, useState } from 'react';
import { Calendar, dateFnsLocalizer, Views } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import cs from 'date-fns/locale/cs';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const locales = { 'cs': cs };
const localizer = dateFnsLocalizer({ format, parse, startOfWeek, getDay, locales });
const Info = withReactContent(Swal);

const CalendarPage = () => {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        fetch('https://ems.lexikonn.eu/api/get_records.php')
            .then(res => res.json())
            .then(data => {
                const mapped = data.map(r => ({
                    title: `${r.pacient} (${r.typ})`,
                    start: new Date(r.dt),
                    end: new Date(r.dt),
                    allDay: false,
                    resource: r,
                }));
                setEvents(mapped);
            });
    }, []);

    const handleEventClick = (event) => {
        const r = event.resource;
        Info.fire({
            title: `${r.pacient} (${r.typ})`,
            html: `
                <b>Zapsal:</b> ${r.user}<br/>
                <b>Discord:</b> ${r.dcuser}<br/>
                <b>Lokalita:</b> ${r.location}<br/>
                <b>Popis:</b><br/><pre style="text-align: left; font-family: monospace; white-space: pre-wrap;">${r.details || '—'}</pre>
            `,
            showDenyButton: true,
            confirmButtonText: 'Duplikovat',
            denyButtonText: 'Zavřít',
            width: 600,
        }).then((result) => {
            if (result.isDenied) {
                window.location.reload();
            }
        });
    };

    const eventColors = {
        'Střelné zranění': '#dc3545',
        'Dopravní nehoda': '#fd7e14',
        'Asistence PD': '#0d6efd',
        'Úmrtí (CK)': '#000000',
        'Jiné': '#6c757d'
    };

    return (
        <div className="container py-5">
            <h2 className="mb-4"><i className="bi bi-calendar3"></i> Kalendář výjezdů</h2>
            <Calendar
                onSelectEvent={handleEventClick}
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                views={[Views.MONTH, Views.WEEK, Views.DAY, Views.AGENDA]}
                defaultView={Views.MONTH}
                style={{ height: 600, backgroundColor: '#f8f9fa', borderRadius: '8px', padding: '20px' }}
                eventPropGetter={(event) => {
                    const bg = eventColors[event.resource.typ] || '#0d6efd';
                    return {
                        style: {
                            backgroundColor: bg,
                            color: '#fff',
                            borderRadius: '4px',
                            padding: '4px',
                            border: 'none',
                        }
                    };
                }}
            />
        </div>
    );
};

export default CalendarPage;
